import { AnyAction } from 'redux';
import {
	BANK_VALIDATION_VALIDATE_IBAN,
	BANK_VALIDATION_VALIDATE_IBAN_CANCEL,
	BANK_VALIDATION_VALIDATE_IBAN_DONE,
	BANK_VALIDATION_VALIDATE_IBAN_FAILED,
} from 'redux/actions/bankValidation';
import { CONTRACT_NEW } from 'redux/actions/contract';
import { BankValidationState } from '../../types/redux';

const initialState: BankValidationState = {
	IBAN: '**',
	bankName: '**',
	BIC: '**',
	isValid: false,
};

export function bankValidationReducer(
	state: BankValidationState = initialState,
	action: AnyAction
): BankValidationState {
	switch (action.type) {
		case CONTRACT_NEW:
		case BANK_VALIDATION_VALIDATE_IBAN_CANCEL:
		case BANK_VALIDATION_VALIDATE_IBAN_FAILED:
			return { ...initialState };

		case BANK_VALIDATION_VALIDATE_IBAN:
			return {
				...state,
				isValid: null,
				IBAN: action.payload.IBAN,
				BIC: '...',
				bankName: '...',
			};

		case BANK_VALIDATION_VALIDATE_IBAN_DONE:
			return {
				...state,
				isValid: true,
				IBAN: action.payload.iban,
				BIC: action.payload.bic[0],
				bankName: action.payload.bankname,
			};

		default:
			return state;
	}
}
